module.exports = __webpack_public_path__ + "img/timebinder-card-bg.0e07fb3f.svg";